module.exports = ".row {\n  margin-left: -10px;\n  margin-right: -10px; }\n"